import * as actionTypes from '_app/mediashare/scenes/CampaignPagePreview/campaignPagePreviewConstants';
import {campaignPageTemplateService, campaignPageService, userInfoService} from '_app/services';

export const getCampaignPageTemplate = (id) => (dispatch) => {
	dispatch(fetchCampaignPageTemplateRequest);

	return campaignPageTemplateService.get(id)
		.then(response => {
			dispatch(fetchCampaignPageTemplateSuccess(response.data));
		})
		.catch(error => {
			dispatch(fetchCampaignPageTemplateFailure(error));
		});
};

export const getCampaignPage = (token) => (dispatch) => {
	dispatch(fetchCampaignPageRequest);

	return campaignPageService.get(token)
		.then(response => {
			dispatch(fetchCampaignPageSuccess(response.data));
		})
		.catch(error => {
			dispatch(fetchCampaignPageFailure(error));
		});
};

export const fetchShareUser = (token, isCampaign) => (dispatch) => {
	dispatch(fetchUserRequest);

	return userInfoService.fetchShareUser(token, isCampaign)
		.then(response => {
			dispatch(fetchUserSuccess(response));
		})
		.catch(error => {
			dispatch(fetchUserFailure(error));
		});
};

const fetchCampaignPageTemplateRequest = {
	type: actionTypes.CAMPAIGN_PAGE_TEMPLATE_FETCH_REQUEST
};

const fetchCampaignPageTemplateSuccess = data => ({
	type: actionTypes.CAMPAIGN_PAGE_TEMPLATE_FETCH_SUCCESS,
	data
});

const fetchCampaignPageTemplateFailure = error => ({
	type: actionTypes.CAMPAIGN_PAGE_TEMPLATE_FETCH_FAILURE,
	errorInfo : error
});

const fetchCampaignPageRequest = {
	type: actionTypes.CAMPAIGN_PAGE_TEMPLATE_FETCH_REQUEST
};

const fetchCampaignPageSuccess = data => ({
	type: actionTypes.CAMPAIGN_PAGE_TEMPLATE_FETCH_SUCCESS,
	data
});

const fetchCampaignPageFailure = error => ({
	type: actionTypes.CAMPAIGN_PAGE_TEMPLATE_FETCH_FAILURE,
	errorInfo : error
});

const fetchUserRequest = {
	type: actionTypes.USER_FETCH_REQUEST
};

const fetchUserSuccess = data => ({
	type: actionTypes.USER_FETCH_SUCCESS,
	data
});

const fetchUserFailure = error => ({
	type: actionTypes.USER_FETCH_FAILURE,
	errorInfo : error
});